import { apiUrl_ } from '../config'
import myAxios from '../myAxios'
import { IPostEditorType } from '@/components/Blogs/useBlogs'

const myBaseUrlDomain = apiUrl_

export const addNewBlogPostToSchoolRequest = (opts: {
  schoolId: string
  title: string
  previewPost: string
  previewImage: string
  post: string
  showOnHomepage: boolean
  published: boolean
  postEditorType: IPostEditorType
}) => {
  const body = {
    schoolId: opts.schoolId,
    title: opts.title,
    previewPost: opts.previewPost,
    post: opts.post,
    showOnHomepage: opts.showOnHomepage,
    previewImage: opts.previewImage,
    published: opts.published,
    postEditorType: opts.postEditorType,
  }
  return myAxios.post(
    `${myBaseUrlDomain}/blogs/posts?&school_id=${opts.schoolId}`,
    body,
  )
}

export const addNewBlogSubscriberToSchoolRequest = (opts: {
  schoolId: string
  email: string
  subscribeArticleId?: string
}) => {
  const body = {
    schoolId: opts.schoolId,
    subscribeArticleId: opts.subscribeArticleId,
    email: opts.email,
  }
  return myAxios.post(
    `${myBaseUrlDomain}/blogs/subscribers?&school_id=${opts.schoolId}`,
    body,
  )
}

export const getBlogSubscriberInSchoolRequest = (opts: {
  schoolId: string
}) => {
  return myAxios.get(
    `${myBaseUrlDomain}/blogs/subscribers?&school_id=${opts.schoolId}`,
  )
}

export const updateBlogPostRequest = (opts: {
  postId: string
  schoolId: string
  title: string
  previewPost: string
  previewImage: string
  post: string
  showOnHomepage: boolean
  archived: boolean
  published: boolean
}) => {
  const body = {
    schoolId: opts.schoolId,
    title: opts.title,
    previewPost: opts.previewPost,
    post: opts.post,
    showOnHomepage: opts.showOnHomepage,
    archived: opts.archived,
    previewImage: opts.previewImage,
    published: opts.published,
  }
  return myAxios.put(
    `${myBaseUrlDomain}/blogs/posts/${opts.postId}?&school_id=${opts.schoolId}`,
    body,
  )
}

export const deleteBlogPostRequest = (opts: {
  postId: string
  schoolId: string
}) => {
  return myAxios.delete(
    `${myBaseUrlDomain}/blogs/posts/${opts.postId}?&school_id=${opts.schoolId}`,
  )
}

export const getSchoolBlogPostsRequest = (opts: {
  schoolId: string
  includeArchived: boolean
  includeUnpublished: boolean
  hideDetails: boolean
}) => {
  return myAxios.get(
    `${myBaseUrlDomain}/blogs/posts?&school_id=${opts.schoolId}&includeArchived=${opts.includeArchived}&hideDetails=${opts.hideDetails}&includeUnpublished=${opts.includeUnpublished}`,
  )
}

export const getSchoolBlogPostDetailsRequest = (opts: {
  postId: string
  schoolId: string
}) => {
  return myAxios.get(
    `${myBaseUrlDomain}/blogs/posts/${opts.postId}?&school_id=${opts.schoolId}`,
  )
}

export const updatePostIndex = (school_id: string, content: any) => {
  const body = { content: content }
  const url = `${myBaseUrlDomain}/blogs/post_index/${school_id}`

  return myAxios.put(url, body)
}
